import { c as _c } from "react/compiler-runtime";
import { translateInline } from '@/globals/translate/translateInline';
import { DOPLink } from '@/uiComposites/interactive/DOPLink';
import { chevronIcon } from '@/uiIcons/chevronIcon.css';
import { CountryMap } from '@/uiIcons/countryMap';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { box } from '@/uiPrimitives/layout/box';
import { subgridRows } from '@/uiPrimitives/layout/pageGrid/subgridRows';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { stack } from '@/uiPrimitives/layout/stack';
import { iconInline } from '@/uiPrimitives/media/iconInline';
import { textBlock } from '@/uiPrimitives/typography/text';
import { addTestSelector } from '@/globals/testHelpers/testSelector';
import { svg } from '@/uiPrimitives/media/svg';
export const RegionalBlock = t0 => {
  const $ = _c(7);
  const {
    regionalSubsidiesPage
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(box({
      padding: "1 | h3",
      borderStyle: "solid",
      borderColor: "negativeBlue",
      borderWidth: "3px"
    }), subgridRows({
      rowGap: "3 | h1",
      alignItems: "start"
    }));
    t2 = addTestSelector("uiRegionalSubsidies");
    t3 = classes(stack({
      rowGap: "3 | h1"
    }));
    t4 = classes(shelf({
      columnGap: "-1 | small",
      gridTemplateColumns: "auto minmax(0, 1fr)",
      alignItems: "start"
    }));
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={t3}><div className={t4}><CountryMap aria-label="Landkaart van Nederland" className={svg({
          inlineSize: {
            all: "7 | betweenH3Sections",
            max640px: "6 | betweenH4Sections"
          },
          blockSize: "auto",
          fill: "positiveBlue"
        })} /><div className={classes(stack({
          rowGap: "3 | h1"
        }))}><span className={classes(textBlock({
            textWrap: "balance",
            fontWeight: "bold",
            capSize: "-1 | small",
            textDecorationLine: "none"
          }))}>{translateInline({
              en: "Know which regional subsidies are available?",
              nl: "Weten welke regionale subsidies er zijn?"
            })}</span><span className={classes(textBlock({
            textWrap: "balance",
            capSize: "-1 | small",
            color: "positiveBlue"
          }))}>{translateInline({
              en: "View our overview per province ",
              nl: "Bekijk ons overzicht per provincie "
            })}<i className={iconInline({
              icon: chevronIcon
            })} /></span></div></div></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== regionalSubsidiesPage) {
    t6 = <DOPLink data-link-type="regionalSubsidies" href={regionalSubsidiesPage} className={t1} {...t2}>{t5}</DOPLink>;
    $[5] = regionalSubsidiesPage;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};